<template>
  <div>
    <a
      href="#"
      class="policy-modal"
      style="font-weight: 700"
      @click.prevent="dialog = !dialog"
      >{{ $t('개인정보처리방침') }}</a
    >
    <base-popup
      v-model="dialog"
      width="80vw"
      title="개인정보처리방침"
      :useCancel="false"
      :useConfirm="false"
    >
      <v-row class="ma-0 px-10 py-1 bg-gray" align="center">
        <v-col cols="8"> </v-col>
        <v-col cols="4" class="pa-0 ma-0" v-if="privacyPolicyDateList">
          <i-select
            :items="privacyPolicyDateList"
            outlined
            hide-details
            v-model="privacyPolicyId"
            class="box-type-02 ma-3"
            height="28"
            item-value="privacyPolicyId"
          />
        </v-col>
      </v-row>
      <v-row
        class="ma-0 px-10 py-1 bg-gray"
        align="center"
        justify="space-between"
      >
        <common-ck-editor class=" py-1" isReadOnly :value="privacyPolicy" />
      </v-row>
    </base-popup>
  </div>
</template>

<script>
import { getJson } from '@/api/network';
import BasePopup from '@/components/common/BasePopup.vue';
import CommonCkEditor from '@/components/common/CommonCkEditor.vue';
const cache = {};
export default {
  components: { BasePopup, CommonCkEditor },
  data() {
    return {
      dialog: false,
      policy: '',

      privacyPolicyDateList: null,
      privacyPolicyId: '',
      privacyPolicy: '',
      privacyPolicyList: [],

      items: null,
    };
  },
  watch: {
    async privacyPolicyId(privacyPolicyId) {
      if (cache.hasOwnProperty(privacyPolicyId)) {
        return (this.privacyPolicy = cache[privacyPolicyId]);
      }
      const close = this.$showLoading();
      const response = await getJson(
        'info/' + this.$route.params.tenantKey + '/policyContent',
        {
          privacyPolicyId,
        },
      ).finally(close);

      this.privacyPolicy = response.data.content;
      cache[privacyPolicyId] = this.privacyPolicy;
    },

    async dialog(v) {
      if (v && this.privacyPolicyDateList == null)
        this.fetchPrivacyPolicyDateList();
    },
  },
  mounted() {
    this.setting();
  },
  methods: {
    setting() {
      getJson('info/' + this.$route.params.tenantKey + '/footer/policy', {})
        .then(res => {
          if (res && res.data && res.data.privacyPolicy) {
            this.policy = res.data.privacyPolicy;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },

    async fetchPrivacyPolicyDateList() {
      const close = this.$showLoading();
      console.log('여기2');
      const resp = await getJson(
        'info/' + this.$route.params.tenantKey + '/policyDate',
        {},
      )
        .finally(close)
        .catch(() => {});
      this.privacyPolicyDateList = resp.data;
      this.privacyPolicyId = this.privacyPolicyDateList[0]?.privacyPolicyId;
    },
  },
};
</script>
